import store from '@/store';
import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import get from 'lodash.get';
import { toast } from 'vue3-toastify';

class Api {
    constructor (options) {
        return this.create(options);
    }

    create (options) {
        const instance = axios.create({
            baseURL: options.baseUrl,
            withCredentials: true,
            headers: {
                post: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            },
            responseType: 'json',
        });

        instance.interceptors.request.use((request) => {
            const quoteToken = localStorage.getItem('APP_QUOTE_TOKEN');
            if (quoteToken) {
                request.headers['X-Quote-token'] = quoteToken;
            } else {
                const token = localStorage.getItem('APP_PORTAL_TOKEN');
                if (token) {
                    request.headers.Authorization = `Bearer ${token}`;
                }
            }

            request.headers.Url = window.location.href;
            return request;
        });

        instance.interceptors.response.use((response) => {
            return response;
        }, (error) => {
            handleErrorMessage(error);
            throw error;
        });

        createAuthRefreshInterceptor(instance, (failedRequest) => {
            return store.dispatch('refresh').catch(() => {
                store.dispatch('logout');
            });
        }, {
            // Only run this middleware for 401 responses.
            statusCodes: [401],
        });

        return instance;
    }
}

/**
 * @param {object} error
 * @param {object} [error.response]
 * @param {number} [error.response.status]
 * @param {object} [error.response.data]
 * @param {object} [error.response.data.message]
 */
function handleErrorMessage (error) {
    const status = get(error, 'response.status');

    // Don't show 404 or 403 errors
    if (status === 404 || status === 403) {
        return;
    }

    if (status === 422) {
        for (const field in error.response.data.errors) {
            if (!Object.prototype.hasOwnProperty.call(error.response.data.errors, field)) {
                continue;
            }

            for (const errorMessage of error.response.data.errors[field]) {
                toast(errorMessage.charAt(0).toUpperCase() + errorMessage.slice(1), {
                    type: toast.TYPE.ERROR,
                });
            }
        }
    }
}

/*
 * Map error messages to displayable messages. Empty values will not be shown.
 */
const errorMessageMap = {
    'You cannot have multiple login sessions per account.': 'Deze behandelaar is ergens anders ingelogd.',
    'Unauthenticated.': null,
};

/**
 * @type {Api}
 */
const api = new Api({
    baseUrl: import.meta.env.VITE_API_URL || '/api',
});

export default api;
